var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.044 24.5334C18.6958 24.5334 24.0881 19.1411 24.0881 12.4893C24.0881 5.83761 18.6958 0.445312 12.044 0.445312C5.39229 0.445312 0 5.83761 0 12.4893C0 19.1411 5.39229 24.5334 12.044 24.5334ZM6.02201 12.6112C6.96363 10.425 9.28773 8.87613 12.0092 8.87613C14.7306 8.87613 17.0547 10.425 17.9963 12.6112C17.0547 14.7975 14.7306 16.3463 12.0092 16.3463C9.28773 16.3463 6.96363 14.7975 6.02201 12.6112ZM9.28773 12.6112C9.28773 13.9857 10.5069 15.1013 12.0092 15.1013C13.5114 15.1013 14.7306 13.9857 14.7306 12.6112C14.7306 11.2367 13.5114 10.1212 12.0092 10.1212C10.5069 10.1212 9.28773 11.2367 9.28773 12.6112ZM10.3763 12.6112C10.3763 11.7845 11.1056 11.1172 12.0092 11.1172C12.9127 11.1172 13.642 11.7845 13.642 12.6112C13.642 13.4379 12.9127 14.1053 12.0092 14.1053C11.1056 14.1053 10.3763 13.4379 10.3763 12.6112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/Icons.e5b446fc58dfa332fb7d2683b594c1ec.svg";
export { ForwardRef as ReactComponent };